const interests = [
  'flirting',
  'romantic',
  'roleplay',
  'chatting',
  'gaming',
  'movies',
  'travel',
  'sports',
  'news',
  'science',
  'animals',
  'cars',
  'astrology',
  'yoga',
  'partying',
  'music',
  'comedy',
  'fishing',
];

const interestsByPriority = interests.slice(0, 5);

export const getMostPrefferedInterest = (interests: string[]) => {
  const userPrioritisedInterests = interests.filter((interest) =>
    interestsByPriority.includes(interest),
  );

  if (userPrioritisedInterests.length === 0) {
    const randomIndex = Math.floor(Math.random() * interests.length);
    return interests[randomIndex];
  }

  const sortedUserPrioritisedInterests = userPrioritisedInterests.sort(
    (a, b) => {
      return interestsByPriority.indexOf(a) < interestsByPriority.indexOf(b)
        ? -1
        : 1;
    },
  );

  return sortedUserPrioritisedInterests[0];
};
